import { html } from "lit";
import { OmniElement } from "../../omni-element.js";
import { omniStyleSheets } from "../../omni-stylesheets.js";
class OmniStyle extends OmniElement {
  _styleListener(event) {
    const { detail = {} } = event;
    if (detail instanceof Function) {
      detail.call(this, event, this);
    } else {
      Object.entries(detail).forEach(this.setProperty, this);
    }
  }
  setProperty([name = "", value = ""]) {
    this.style.setProperty(name, value);
  }
  constructor() {
    super();
    this._styleListener = this._styleListener.bind(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    self.removeEventListener("omni-style", this._styleListener);
  }
  connectedCallback() {
    super.connectedCallback();
    self.addEventListener("omni-style", this._styleListener);
    const root = this.getRootNode();
    if (root instanceof HTMLDocument && this.children.length === 0) {
      root.firstElementChild.classList.add("omni");
    } else if (!this.closest(".omni")) this.classList.add("omni");
    if (!root.adoptedStyleSheets.includes(omniStyleSheets[0])) {
      root.adoptedStyleSheets = [
        ...omniStyleSheets,
        // inject shared omni sheets first, so component sheets can override
        //@ts-ignore
        ...root.adoptedStyleSheets
      ];
    }
  }
  render() {
    return html`<slot></slot>`;
  }
}
OmniElement.register("omni-style", OmniStyle);
export {
  OmniStyle
};
//# sourceMappingURL=omni-style.js.map
